<div class="container-fluid header-img">
    <div class="logo py-2">
        <img src="../../../../assets/images/New_logo.png"  height="86px" width="220px" />
    </div>
</div>
